/** Thrown when background indexing should yield to an in-flight file browser request. */
export class SymbolIndexDeferredError extends Error {
  constructor() {
    super('Symbol indexing deferred for file browser');
    this.name = 'SymbolIndexDeferredError';
  }
}

export function isSymbolIndexDeferredError(err: unknown): err is SymbolIndexDeferredError {
  return err instanceof SymbolIndexDeferredError;
}
